import type { ICampaignSaveBody } from "~/interfaces/ICampaignRepository";

// キャンペイン詳細
export class Campaign {
  constructor(
    public campaignId: number,
    public campaignTitle: string,
    public campaignType: string,
    public contractUserCount: number,
    public displayUserCount: number,
    public pageContents: string,
    public planId: string,
    public planTitle: string,
    public status: string,
    public createdAt: string,
    public displayPlanPrice: {
      planPriceId: string;
      planPrice: number;
      priceName: string;
    },
    public offerPlanPrice: {
      contractPeriod: number;
      isSubscription: number;
      planPriceId: string;
      price: number;
      priceName: string;
      startDate: string;
      billingType?: string;
      deliveryFrequency?: string;
      // options for local variable
      endDate?: string;
    },
  ) {}
}

export const emptyCampaign = () =>
  new Campaign(
    0,
    "",
    "",
    0,
    0,
    "",
    "",
    "",
    "",
    "",
    {
      planPriceId: "",
      planPrice: 0,
      priceName: "",
    },
    {
      contractPeriod: 0,
      isSubscription: 0,
      planPriceId: "",
      price: 0,
      priceName: "",
      startDate: "",
    },
  );

export const toCampaignSeed = (data: Campaign, options: Partial<ICampaignSaveBody> = {}): ICampaignSaveBody => {
  return {
    campaign_title: data.campaignTitle,
    page_contents: data.pageContents,
    campaign_type: data.campaignType,
    status: data.status,
    plan_id: "",
    display_plan_price_id: "",
    campaign_plan_price_id: "",
    ...options,
  };
};
